import { Layers } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const AnnotationMapIcon = DeckardIconWrapper({ Icon: Layers });
